import * as angular from "angular";
angular
    .module("leaderTheme", ["ngMaterial"])
    .config(($mdThemingProvider: any) => {
        const primaryColor = "#44b4cb"; //Primary colour for this brand
        const darkColor = "#252c4a"; //Dark color used for sidebar navigation
        const lightBackgroundColor = "#f0f6f8"; //Main background color, should be close to grey with a hint of primary color

        $mdThemingProvider.definePalette("main", {
            "50": "e9f6f9",
            "100": "c7e9ef",
            "200": "a2dae5",
            "300": "7ccbdb",
            "400": "60bfd3",
            "500": "44b4cb",
            "600": "3eadc6",
            "700": "35a4be",
            "800": "2d9cb8",
            "900": "1f8cac",
            A100: "e5f9ff",
            A200: "b2edff",
            A400: "7fe0ff",
            A700: "65daff",
            contrastDefaultColor: "light",
        });

        // ------------------------------------------------
        // ------------------------------------------------
        // ------------------------------------------------
        // YOU DO NOT NEED TO EDIT ANYTHING BELOW THIS LINE
        // ------------------------------------------------
        // ------------------------------------------------
        // ------------------------------------------------

        const grey = $mdThemingProvider.extendPalette("grey", {
            50: lightBackgroundColor,
        });

        $mdThemingProvider.definePalette("navbarPalette", {
            50: primaryColor,
            100: primaryColor,
            200: primaryColor,
            300: primaryColor,
            400: primaryColor,
            500: primaryColor,
            600: primaryColor,
            700: primaryColor,
            800: primaryColor,
            900: primaryColor,
            A100: primaryColor,
            A200: primaryColor,
            A400: primaryColor,
            A700: primaryColor,
            contrastDefaultColor: "light",
            contrastDarkColors: [
                "50",
                "100",
                "200",
                "300",
                "A100",
                "A200",
                "A400",
                "A700",
            ],
            contrastLightColors: ["400", "500", "600", "700", "800", "900"],
        });

        $mdThemingProvider.definePalette("darkBrand", {
            50: darkColor,
            100: darkColor,
            200: darkColor,
            300: darkColor,
            400: darkColor,
            500: darkColor,
            600: darkColor,
            700: darkColor,
            800: darkColor,
            900: darkColor,
            A100: darkColor,
            A200: darkColor,
            A400: darkColor,
            A700: darkColor,
            contrastDefaultColor: "light",
        });

        $mdThemingProvider.definePalette("white", {
            50: "#000",
            100: "#000", //tab item non selected colour
            200: "#000", //body background colour
            300: "#000",
            400: "#000", //search box
            500: "#000",
            600: "#000", //select option selected
            700: "#000",
            800: "#000",
            900: "#000",
            A100: "#000",
            A200: "#000", //toolbar background color
            A300: "#000",
            A400: "#000",
            A700: "#000",
            contrastDefaultColor: "dark", // whether, by default, text (contrast)
        });

        $mdThemingProvider
            .theme("darkBackground")
            .primaryPalette("darkBrand")
            .accentPalette("darkBrand")
            .warnPalette("red")
            .backgroundPalette("darkBrand")
            .dark();

        $mdThemingProvider.definePalette("brandGrey", grey);

        $mdThemingProvider
            .theme("navbar")
            .primaryPalette("navbarPalette")
            .accentPalette("navbarPalette")
            .warnPalette("red")
            .backgroundPalette("brandGrey");

        $mdThemingProvider
            .theme("default")
            .primaryPalette("main")
            .accentPalette("white")
            .warnPalette("red")
            .backgroundPalette("brandGrey");
    });
